export const TITLE = [
  {
    label: "Mr",
    value: "Mr",
  },
  {
    label: "Mrs",
    value: "Mrs",
  },
  {
    label: "Chief",
    value: "Chief",
  },
  {
    label: "Miss",
    value: "Miss",
  },
  {
    label: "Master",
    value: "Master",
  },
  {
    label: "Dr",
    value: "Dr",
  },
  {
    label: "Engr",
    value: "Engr",
  },
  {
    label: "Prof",
    value: "Prof",
  },
  {
    label: "Barr",
    value: "Barr",
  },
  {
    label: "Hon",
    value: "Hon",
  },
];

export const RECIPIENT_ROLE = [
  { key: "MDA_ACCOUNTING_OFFICER", value: "Permanent Secretary" },
  { key: "MDA_SUPERVISING_OFFICER", value: "Honorable commissioner" },
  { key: "MDA_REVIEWER", value: "Reviewer" },
  { key: "MDA_INITIATOR", value: "Initiator" },
];

export const Roles = {
  SUPERADMIN: "SUPERADMIN",
  ADMIN: "ADMIN",
  IT_ADMIN: "IT_ADMIN",
  MDA_ADMIN: "MDA_ADMIN",
  BUDGET_ADMIN: "BUDGET_ADMIN",
  EMM_ADMIN: "EMM_ADMIN",
  GLOBAL_AUDITOR: "GLOBAL_AUDITOR",
  MDA_REVIEWER: "MDA_REVIEWER",
  MDA_INITIATOR: "MDA_INITIATOR",
  MDA_INTERNAL_AUDITOR: "MDA_INTERNAL_AUDITOR",
  MDA_AUTHORIZER: "MDA_AUTHORIZER",
  MDA_CHECKER: "MDA_CHECKER",
  MDA_ACCOUNTING_OFFICER: "MDA_ACCOUNTING_OFFICER",
  MDA_SUPERVISING_OFFICER: "MDA_SUPERVISING_OFFICER",
  DIRECTOR_OF_EXPENDITURE: "DIRECTOR_OF_EXPENDITURE",
  WARRANT_INITIATOR: "WARRANT_INITIATOR",
  WARRANT_AUTHORISER: "WARRANT_AUTHORISER",
  WARRANT_REQUEST_REVIEWER: "WARRANT_REQUEST_REVIEWER",
  PAYMENT_REQUEST_PROCESSING_INITIATOR: "PAYMENT_REQUEST_PROCESSING_INITIATOR",
  CONTRACT_PAYMENT_REQUEST_PROCESSING_CHECKER: "CONTRACT_PAYMENT_REQUEST_PROCESSING_CHECKER",
  EXPENDITURE_REQUEST_REVIEWER: "EXPENDITURE_REQUEST_REVIEWER",
  EXPENDITURE_CLEARANCE_INITIATOR: "EXPENDITURE_CLEARANCE_INITIATOR",
  EXPENDITURE_CLEARANCE_AUTHORISER: "EXPENDITURE_CLEARANCE_AUTHORISER",
  PAYMENT_REQUEST_PROCESSING_REVIEWER: "PAYMENT_REQUEST_PROCESSING_REVIEWER",
  PAYMENT_REQUEST_PROCESSING_AUTHORISER: "PAYMENT_REQUEST_PROCESSING_AUTHORISER",
  SE_EXPENDITURE: "SE_EXPENDITURE",
  CASH_OFFICER: "CASH_OFFICER",
  GLO_INITIATOR: "GLO_INITIATOR",
  GLO_REVIEWER: "GLO_REVIEWER",
  FUNDS_MANAGER: "FUNDS_MANAGER",
  SE_FUND_RELEASE: "SE_FUND_RELEASE",
  SE_WARRANT: "SE_WARRANT",
  MDA_AUTHORISER: "MDA_AUTHORISER",
  WARRANT_REQUEST_AUTHORISER: "WARRANT_REQUEST_AUTHORISER",
  CONTRACT_PAYMENT_REQUEST_REVIEWER: "CONTRACT_PAYMENT_REQUEST_REVIEWER",
  TREASURY_CASH_OFFICER: "TREASURY_CASH_OFFICER",
  WARRANT_REQUEST_APPROVER: "WARRANT_REQUEST_APPROVER",
  RECONCILIATION_INITIATOR: "RECONCILIATION_INITIATOR",
  RECONCILIATION_AUTHORISER: "RECONCILIATION_AUTHORISER",
  MDA_MODERATOR: "MDA_MODERATOR",
  VOTE_BOOK_OFFICER: "VOTE_BOOK_OFFICER",
  WARRANT_REQUEST_CHECKER: "WARRANT_REQUEST_CHECKER",
  EXPENDITURE_CLEARANCE_CHECKER: "EXPENDITURE_CLEARANCE_CHECKER",
  WARRANT_REQUEST_ENDORSER: "WARRANT_REQUEST_ENDORSER",
  EXPENDITURE_DIGITIZATION_INITIATOR: "EXPENDITURE_DIGITIZATION_INITIATOR",
  EXPENDITURE_DIGITIZATION_REVIEWER: "EXPENDITURE_DIGITIZATION_REVIEWER",
  EXPENDITURE_DIGITIZATION_AUTHORISER: "EXPENDITURE_DIGITIZATION_AUTHORISER",
  WARRANT_DIGITIZATION_INITIATOR: "WARRANT_DIGITIZATION_INITIATOR",
  WARRANT_DIGITIZATION_REVIEWER: "WARRANT_DIGITIZATION_REVIEWER",
  WARRANT_DIGITIZATION_AUTHORISER: "WARRANT_DIGITIZATION_AUTHORISER",
  WARRANT_GENERATION_INITIATOR: "WARRANT_GENERATION_INITIATOR",
  WARRANT_GENERATION_REVIEWER: "WARRANT_GENERATION_REVIEWER",
  WARRANT_GENERATION_AUTHORISER: "WARRANT_GENERATION_AUTHORISER",
  EXPENDITURE_CLEARANCE_ENDORSER: "EXPENDITURE_CLEARANCE_ENDORSER",
  EXPENDITURE_CLEARANCE_APPROVER: "EXPENDITURE_CLEARANCE_APPROVER",
};

export const FINANCE_MDA_NAME = "Ministry of Finance";

export const WARRANT_ISSUANCE_WITHDRAW_ROLES = [
  Roles.WARRANT_REQUEST_CHECKER,
  Roles.WARRANT_REQUEST_AUTHORISER,
  Roles.WARRANT_REQUEST_REVIEWER,
  Roles.WARRANT_REQUEST_ENDORSER,
  Roles.WARRANT_REQUEST_APPROVER,
];
export const Modules = { GMM: "GMM", EMM: "EMM", WMM: "WMM", DMM: "DMM" };

export const ASIDE_CONTENT = [
  {
    title: "Registration Progress",
    description: "Fill in the fields to complete the user registration",
  },
];
